var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path, _rect11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 216,
    viewBox: "0 0 216 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 108,
    r: 108,
    fill: "#EFF4F8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 45.0002,
    width: 90,
    height: 123,
    rx: 6,
    fill: "#D7E0E9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46.7607,
    y: 44.3828,
    width: 88.9866,
    height: 121.345,
    rx: 6,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 92.3506,
    y: 33.5471,
    width: 91.0716,
    height: 121.811,
    rx: 6,
    transform: "rotate(15 92.3506 33.5471)",
    fill: "#D7E0E9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 93.0342,
    y: 32.9985,
    width: 88.9866,
    height: 121.345,
    rx: 6,
    transform: "rotate(15 93.0342 32.9985)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 97.0742,
    y: 48.5366,
    width: 29.4539,
    height: 6,
    rx: 3,
    transform: "rotate(15 97.0742 48.5366)",
    fill: "#D7E0E9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 93.71,
    y: 61.0938,
    width: 70.739,
    height: 6,
    rx: 3,
    transform: "rotate(15 93.71 61.0938)",
    fill: "#D7E0E9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 90.3447,
    y: 73.6506,
    width: 70.739,
    height: 6,
    rx: 3,
    transform: "rotate(15 90.3447 73.6506)",
    fill: "#D7E0E9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 86.9805,
    y: 86.2078,
    width: 70.739,
    height: 6,
    rx: 3,
    transform: "rotate(15 86.9805 86.2078)",
    fill: "#D7E0E9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 83.6152,
    y: 98.7646,
    width: 70.739,
    height: 6,
    rx: 3,
    transform: "rotate(15 83.6152 98.7646)",
    fill: "#D7E0E9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 80.251,
    y: 111.322,
    width: 48.5155,
    height: 6,
    rx: 3,
    transform: "rotate(15 80.251 111.322)",
    fill: "#D7E0E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M179.528 77.4272L186.5 85.5L125 160.5L117.999 154.643L179.528 77.4272Z",
    fill: "#BB3354"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 179.072,
    y: 77,
    width: 9.64027,
    height: 98,
    transform: "rotate(38.5495 179.072 77)",
    fill: "#E2445C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.3ebe6abdab392a0d2ad1f078ce2b8f3b.svg";
export { ForwardRef as ReactComponent };